// extracted by mini-css-extract-plugin
export default {"listCard":"social-skeletons-ListCardLoadingSkeleton__listCard--1JT1f","list":"social-skeletons-ListCardLoadingSkeleton__list--OcX0D"};